<div class="db-orders-section">
<section class="ecommerce-view-body-wrapper {{order?.line_items}}">
  <div class="ecommerce-table-row heads"
       [ngStyle]="headerGreedStyleRefund">
    <span *ngFor="let head of order?.tax_lines?.length ? heads : updatedHeads" [innerHTML]="head"></span>
  </div>
  <ng-content></ng-content>
  <div class="list">
    <ng-container *ngIf="order?.line_items && order?.line_items.length">
      <div class="order-row"
               *ngFor="let item of order?.line_items; let i = index"
      [ngStyle]="headerGreedStyleRefund">
        <!--<div class="order-select row-item">
          <input class="ds-checkbox" type="checkbox"  id="selectItem"  [checked]="itemSelected[i]"
                 (change)="toggleSelection(i)">
          <label for="selectItem" class="black"></label>
        </div>-->
        <div class="order-image-container row-item">
          <img *ngIf="item?.image && item?.image.src" [src]="item?.image?.src" alt="img"/>
        </div>
        <div class="order-title row-item">
          <a class="product-link long-text" [routerLink]="'/websites/' + this.websiteId + '/ecommerce/products/edit-product/'+item?.product_id">
            {{item?.parent_name || item?.name}}
          </a>
          <p *ngIf="item?.meta_data">
            <span *ngIf="item?.meta_data[1]?.value">{{item?.meta_data[1]?.value}}, </span>
            <span *ngIf="item?.meta_data[0]?.value">{{item?.meta_data[0]?.value}}</span>
          </p>
        </div>
        <div class="order-inventory row-item">
          {{ item?.quantity }}
          <db-refund-price *ngIf="Math.abs(item?.refund_details?.quantity) > 0"
                           [price]="item?.refund_details?.quantity">
          </db-refund-price>
        </div>
        <div class="order-inventory row-item">
          <db-refund-items   [quantity]="item.quantity - Math.abs(item?.refund_details?.quantity)"
                             [fullRefund]="fullRefund"
                             [reset]="resetEmitter.asObservable()"
                             (quantityChange)="!fullRefund && handleQuantityChange(i,$event)">
          </db-refund-items>
        </div>
        <div class="order-price row-item">
          ${{ (item.price * item.quantity) | DbNumberFormatPipe: 'halfUp' : 2 }}
          <db-refund-price
                *ngIf="Math.abs(item?.refund_details?.total) > 0"
                [price]="'-$' + Math.abs(item?.refund_details?.total | DbNumberFormatPipe: 'halfUp' : 2)">
        </db-refund-price>
        </div>
        <div class="order-refund-amount row-item">
          <div class="ds-input-wrap static" style="position: relative;">
            <span class="db-dollar" *ngIf="!!itemRefundAmounts[i]">$</span>
            <input type="number" class="ds-input"
                   [placeholder]="'$0.00'"
                   [readonly]="!!fullRefund"
                   [max]="item.price * (item.quantity - Math.abs(item?.refund_details?.quantity))"
                   [ngClass]="{'error': itemRefundAmounts[i] > (item.price * (item.quantity - Math.abs(item?.refund_details?.quantity)) | DbNumberFormatPipe: 'halfUp' : 2),
                               'empty': !itemRefundAmounts[i]}"
                   (change)="changeTotalRefundAmout(itemRefundAmounts[i] > item.price * (item.quantity - Math.abs(item?.refund_details?.quantity)), i, 'amount')"
                   [value]="itemRefundAmounts[i]" (input)="onItemRefundAmountChange(i, $event)"
                   name="refundAmount{{i}}">
          </div>
        </div>
        <div class="order-price row-item" *ngIf="item?.taxes?.length">
          ${{ +item.total_tax | DbNumberFormatPipe: 'halfUp' : 2 }}
          <db-refund-price
                  *ngIf="Math.abs(item?.refund_details?.total_tax) > 0"
                  [price]="'-$' + Math.abs(item?.refund_details?.total_tax | DbNumberFormatPipe: 'halfUp' : 2)">
          </db-refund-price>
        </div>
        <div class="order-refund-amount row-item" *ngIf="item?.taxes?.length">
          <div class="ds-input-wrap pb0">
            <span class="db-dollar" *ngIf="!!itemRefundTaxes[i]">$</span>
            <input type="number" class="ds-input"
                   [placeholder]="'$0.00'"
                   [readonly]="!!fullRefund"
                   [max]="item.total_tax * (item.quantity - (item?.refund_details?.quantity ? Math.abs(item?.refund_details?.quantity) : 0))"
                   [ngClass]="{'error': itemRefundTaxes[i] > item.total_tax * (item.quantity - (item?.refund_details?.quantity ? Math.abs(item?.refund_details?.quantity) : 0)),
                               'empty': !itemRefundTaxes[i]}"
                   (change)="changeTotalRefundAmout(itemRefundTaxes[i] > item.total_tax * (item.quantity - (item?.refund_details?.quantity ? Math.abs(item?.refund_details?.quantity) : 0)), i, 'tax')"
                   [value]="itemRefundTaxes[i]" (input)="onItemRefundTaxChange(i, $event)"
                   name="refundAmount{{i}}">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
  <div class="db-update-stock">
    <input class="ds-checkbox" type="checkbox"  id="editCheckbox" (change)="onCheckboxChange()" [checked]="update">
    <label for="editCheckbox" class="ds-checkbox-label black mb0">
      <span class="text">{{ 'text_automaticallyRestockYourRefundedItems' | dbText }}
      <i class="db-icon db-icon-info-lined ml5"
         [dsTooltip]="'text_youCanRestockYourProductsByChangingTheRefundQuantity' | dbText"
         [dsTooltipColor]="'black'"
         [hostClass]="'cover-all'"
         dsTooltipPosition="right"
         dsTooltipAlign="bottom"></i>
      </span>
    </label>
  </div>
</div>

<section class="ecommerce-view-sidebar-wrapper">
  <div class="sidebar-items-wrapper">
    <div class="ecommerce-view-sidebar-header">
      <div>{{ 'text_shippingRefund' | dbText }}</div>
    </div>
    <div class="db-refund-amounts" *ngIf="order?.shipping_lines?.length">
      <div class="ds-input-wrap static">
        <div>
          <span class="ds-input-label mb2">{{ 'text_shipping' | dbText }}</span>
          <span class="ds-input-desc pl0" *ngIf="!hasShippingErrors">
            Shipping amount ${{ (order?.shipping_total - +refundedShippingAmount)  | DbNumberFormatPipe: 'halfUp' : 2 }}
          </span>
        </div>
        <div class="db-refund-amounts__input">
          <span class="db-dollar" *ngIf="!!shippingAmount">$</span>
          <input type="number" class="ds-input"
                 [placeholder]="'$0.00'"
                 [readonly]="!!fullRefund"
                 [ngClass]="{'error': hasShippingErrors || (shippingAmount > ((order?.shipping_total - +refundedShippingAmount) | DbNumberFormatPipe: 'halfUp' : 2)),
                             'empty': !shippingAmount}"
                 [value]="shippingAmount" (input)="onShippingAmountChange($event)"
                 name="shippingAmount">
          <span class="ds-input-error-msg" *ngIf="hasShippingErrors || (shippingAmount > ((order?.shipping_total - +refundedShippingAmount) | DbNumberFormatPipe: 'halfUp' : 2))">
            Max refund amount ${{ (order?.shipping_total - +refundedShippingAmount) | DbNumberFormatPipe: 'halfUp' : 2 }}
          </span>
        </div>
      </div>
    </div>
    <div class="db-refund-amounts">
      <div class="ds-input-wrap static">
        <div>
          <span class="ds-input-label mb2">{{ 'text_shippingTax' | dbText }}</span>
          <span class="ds-input-desc pl0" *ngIf="!hasShippingErrors">
            Tax amount ${{ (order?.shipping_tax - +refundedShippingTaxAmount) | DbNumberFormatPipe: 'halfUp' : 2 }}
          </span>
        </div>
        <div class="db-refund-amounts__input">
          <span class="db-dollar" *ngIf="!!shippingTax">$</span>
          <input type="number" class="ds-input"
                 [placeholder]="'$0.00'"
                 [readonly]="!!fullRefund"
                 [ngClass]="{'error': hasShippingErrors || (shippingTax > ((order?.shipping_tax - +refundedShippingTaxAmount) | DbNumberFormatPipe: 'halfUp' : 2)),
                             'empty': !shippingTax}"
                 [value]="shippingTax" (input)="onShippingTaxChange($event)"
                 name="shippingTax">
          <span class="ds-input-error-msg" *ngIf="hasShippingErrors || (shippingTax > ((order?.shipping_tax - +refundedShippingTaxAmount) | DbNumberFormatPipe: 'halfUp' : 2))">
            Max refund amount ${{ (order?.shipping_tax - +refundedShippingTaxAmount) | DbNumberFormatPipe: 'halfUp' : 2 }}
          </span>
        </div>
      </div>
    </div>
    <div class="db-refund-amounts" *ngIf="!order?.tax_lines?.length">
      <div class="ds-input-wrap centered static">
        <div>
          <span class="ds-input-label">{{ 'text_refundAmount' | dbText }}</span>
        </div>
        <div class="db-refund-amounts__input">
          <span class="db-dollar" *ngIf="!!refundAmount">$</span>
          <input
                 type="number"
                 class="ds-input"
                 [placeholder]="'$0.00'"
                 [max]="totalRefundValue"
                 [readonly]="!!fullRefund"
                 [ngClass]="{'error': +refundAmount > ((+order?.total - refundsTotalSum) | DbNumberFormatPipe: 'halfUp' : 2),
                             'empty': !refundAmount}"
                 [value]="refundAmount" (input)="onRefundAmountChange($event)"
                 name="refundAmount">
          <span class="ds-input-error-msg" *ngIf="+refundAmount > ((+order?.total - refundsTotalSum) | DbNumberFormatPipe: 'halfUp' : 2)">
            Max refund amount ${{ (+order?.total - refundsTotalSum) | DbNumberFormatPipe: 'halfUp' : 2 }}
          </span>
        </div>
      </div>
    </div>

  </div>
  <div class="ecommerce-view-sidebar-footer">
    <div class="ecommerce-view-sidebar-footer-item">
      <div class="ecommerce-view-sidebar-footer-item-label">
        {{ 'text_refundAmount' | dbText }}
      </div>
      <div class="ecommerce-view-sidebar-footer-item-value">
        ${{ ((shippingAmount ? +shippingAmount : 0) + (refundAmount ? +refundAmount : 0) + (shippingTax ? +shippingTax : 0)) | DbNumberFormatPipe: 'halfUp' : 2  }}
      </div>
    </div>
    <div class="ecommerce-view-sidebar-footer-available">
      <div class="ecommerce-view-sidebar-footer-item-label">
        {{ 'text_availableMaxRefund' | dbText }}
      </div>
      <div class="ecommerce-view-sidebar-footer-item-value">
        ${{ (+order?.total - refundsTotalSum) | DbNumberFormatPipe: 'halfUp': 2 }}
      </div>
    </div>
    <div class="ds-btn-m ds-btn-black mt20 {{hasRefundErrors}}"
         [ngClass]="{'ds-btn-disabled': hasRefundErrors || loading || hasRefundErrorsWithTax
                                        || ((shippingAmount ? +shippingAmount : 0) + (refundAmount ? +refundAmount : 0) + (shippingTax ? +shippingTax : 0) === 0)
                                        || (shippingAmount ? +shippingAmount : 0) + (refundAmount ? +refundAmount : 0) + (shippingTax ? +shippingTax : 0) > ((+order?.total - +refundsTotalSum) | DbNumberFormatPipe: 'halfUp' : 2)
                                        || (shippingAmount > ((order?.shipping_total - +refundedShippingAmount) | DbNumberFormatPipe: 'halfUp' : 2))
                                        || (shippingTax > ((order?.shipping_tax - +refundedShippingTaxAmount) | DbNumberFormatPipe: 'halfUp' : 2)) }"
         (click)="refundOrder()">
      <span *ngIf="!loading">{{!!fullRefund ? ('text_fullRefund' | dbText) : ('text_refund' | dbText)}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner></div>
  </div>

</section>
